// Re-export from common location for backwards compatibility
import PropertyTypeFilter from "../../common/PropertyTypeFilter";
export default PropertyTypeFilter;
